import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Login from "@/pages/admin/Login";
import Admin from "@/pages/admin/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
}

function ProtectedRoute({ children }) {
  const { user } = useApp();
  if (user === null) return <div className="min-h-screen grid place-items-center font-display">…</div>;
  if (!user) { window.location.href = "/admin/login"; return null; }
  return children;
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollTop />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/leistungen" element={<Services />} />
              <Route path="/projekte" element={<Gallery />} />
              <Route path="/projekte/:id" element={<ProjectDetail />} />
              <Route path="/ueber-uns" element={<About />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/impressum" element={<Legal type="imprint" />} />
              <Route path="/datenschutz" element={<Legal type="privacy" />} />
            </Route>
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
